import React from 'react';
import {
    View,
    TouchableOpacity,
} from 'react-native';
import { connect } from 'react-redux';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {DrawerActions} from '@react-navigation/native';
import IAppState from "../Models/App/IAppState";
import AppText from "./AppText";
import {saveUser} from "../Models/User/UserActions";
import IUser from "../Models/User/IUser";
import {EUserType} from "../Models/User/EUserType";
import {AnyAction} from "redux";

interface IProps {
    navigation: any;
    user?: IUser;
    saveUser: (user: IUser | undefined) => AnyAction;
    /** Close web modal menu (web only). */
    onClose?: () => void;
    /**
     * Native drawer wraps screens in "MyStack".
     * Web modal menu navigates the stack directly.
     */
    nestedInDrawer?: boolean;
}

interface MenuItem {
    pageName: string;
    route: string;
}

class DrawerMenu extends React.Component<IProps> {
    getMenu(): MenuItem[] {
        if (this.props.user && this.props.user.type === EUserType.courier) {
            return [
                {pageName: 'פתיחת הזמנה', route: 'OpenOrder'},
                {pageName: 'הזמנות', route: 'OrderHistory'},
                {pageName: 'התנתק', route: 'Login'},
            ];
        }

        return [
            {pageName: 'לקוחות', route: 'Clients'},
            {pageName: 'שליחים', route: 'Courier'},
            {pageName: 'פתיחת הזמנה', route: 'OpenOrder'},
            {pageName: 'הזמנות', route: 'OrderHistory'},
            {pageName: 'התנתק', route: 'Login'},
        ];
    }

    async navTo(route: string) {
        this.props.onClose?.();

        if (this.props.nestedInDrawer) {
            this.props.navigation.dispatch(DrawerActions.closeDrawer());
        }

        if (route === 'Login') {
            await AsyncStorage.removeItem('user');
            await AsyncStorage.removeItem('token');
            this.props.saveUser(undefined);
        }

        if (this.props.nestedInDrawer) {
            this.props.navigation.navigate('MyStack', {screen: route});
        } else {
            this.props.navigation.navigate(route);
        }
    }

    render() {
        return (
            <View style={{backgroundColor: 'white', width: '100%', height: '100%', marginTop: 100, paddingLeft: 15, paddingRight: 15}}>
                {this.getMenu().map(p => (
                    <TouchableOpacity
                        key={p.route + p.pageName}
                        onPress={() => this.navTo(p.route)}
                        style={{borderBottomColor: '#019FB2', width: '100%', borderBottomWidth: 2, paddingBottom: 5, marginTop: 5}}>
                        <AppText style={{fontSize: 20, textAlign: 'left'}}>{p.pageName}</AppText>
                    </TouchableOpacity>
                ))}
            </View>
        );
    }
}

const mapStateToProps = (state: IAppState) => ({
    user: state.user.current,
});

const mapDispatchToProps = {
    saveUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawerMenu);
